import conn from "./connections";

export const registerAccount = newAccountData =>
  conn.postJSON(`${conn.base_url}/register`, newAccountData);
